import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { processById } from '@/store/modules/processes/getters';

const buildGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

export const loading = buildGetterObject('loading');
export const id = buildGetterObject('id');
export const process = buildGetterObject('process');
export const availableWorkflows = buildGetterObject('availableWorkflows');

const getters = {
	[loading.getter]: ({ loading }) => loading,
	[id.getter]: ({ id }) => id,
	[process.getter]: (state, getters, rootState, rootGetters) => rootGetters[processById.fullPath](getters[id.getter]),
	[availableWorkflows.getter]: ({ availableWorkflows }) => availableWorkflows,
};

export default getters;
